import React from 'react';

import { Box, Button, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { FIRST_PAGE, PAGES_LABEL } from '../../FormChangeHistory.constants';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import usePageSelect from '../../hooks/usePageSelect';
import PreviewMarkBadge from '../PreviewMarkBadge';

import { pageButtonStyles, pageRailStyles } from './PreviewPageRail.styles';

/** The pages of the longer side, each with how many marked changes it carries. */
const PreviewPageRail = ({ pageCount, selectedPage, onSelectPage, markCounts = {} }) => {
  const onPageClick = usePageSelect(onSelectPage);

  return (
    <Box sx={pageRailStyles}>
      <Typography color="text.secondary" variant="medium12">
        {PAGES_LABEL}
      </Typography>
      {_.range(FIRST_PAGE, pageCount + 1).map(pageNumber => {
        const isSelected = pageNumber === selectedPage;
        const markCount = markCounts[pageNumber] ?? 0;

        return (
          <Button
            aria-current={isSelected}
            data-page={pageNumber}
            data-testid={FormChangeHistoryTestIds.PREVIEW_PAGE_BUTTON}
            key={pageNumber}
            sx={pageButtonStyles}
            variant={isSelected ? 'contained' : 'line'}
            onClick={onPageClick}
          >
            {pageNumber}
            {markCount > 0 && (
              <PreviewMarkBadge
                dataTestId={FormChangeHistoryTestIds.PREVIEW_PAGE_MARK_COUNT}
                number={markCount}
              />
            )}
          </Button>
        );
      })}
    </Box>
  );
};

PreviewPageRail.propTypes = {
  pageCount: PropTypes.number.isRequired,
  selectedPage: PropTypes.number.isRequired,
  onSelectPage: PropTypes.func.isRequired,
  markCounts: PropTypes.objectOf(PropTypes.number),
};

export default PreviewPageRail;
